import Api from "~/service/Api";

class InvoiceRepository {
  fetch(query = {}) {
    return Api.get("/invoices", query);
  }

  fetchOne(invoiceId) {
    return Api.get(`/invoices/${invoiceId}`);
  }
}

export default InvoiceRepository;
